import React from "react";

type status = "ACTIVE" | "INACTIVE" | "RESTOCKING" | "COMPLETED" | "CANCELLED";
type mark = "AVAILABLE" | "DISCONTINUE" | "OUT_OF_STOCK" | "DISCOUNT_OFFER" | "NOT_APPROVED";
type order = "STOCK" | "DATE" | "SALES" | "NEW_STOCK";
type sort = "ASC" | "DESC";
export interface FilterContextState {
  status: status[];
  mark: mark[];
  vendor: number[];
  brand: number[];
  categories: number[];
  isRemoted: "T" | "F" | null;
  gteStock: number | undefined;
  lteStock: number | undefined;
  gteDiscount: number | undefined;
  lteDiscount: number | undefined;
  field: order;
  sortBy: sort;
  offset: number;
  limit: number;
  viewBySku: "T" | "F";
  typesearch: string | undefined;
  search: string | undefined;
  is_filter_change: boolean;
}

export const initialFilterState: FilterContextState = {
  status: ["ACTIVE"],
  mark: [],
  vendor: [],
  brand: [],
  categories: [],
  isRemoted: null,
  gteStock: undefined,
  lteStock: undefined,
  gteDiscount: undefined,
  lteDiscount: undefined,
  field: "DATE",
  sortBy: "DESC",
  offset: 0,
  limit: 40,
  viewBySku: "F",
  search: "",
  typesearch: undefined,
  is_filter_change: true,
};

interface IState {
  state: FilterContextState;
  setState: (state: FilterContextState) => void;
}

export const FilterContext = React.createContext<IState>({
  state: initialFilterState,
  setState: (value) => {},
});
